import React from 'react';
import { store } from 'react-notifications-component';
import { StatusBanner } from '@xingternal/banner';

import styles from './styles.css';

const addNotification = (
  message: string,
  notificationType: 'ERROR' | 'INFO'
): void => {
  const variant = notificationType === 'ERROR' ? 'error' : 'info';

  store.addNotification({
    insert: 'top',
    container: 'top-right',
    animationIn: ['animated', 'fadeIn'],
    animationOut: ['animated', 'fadeOut'],
    content: (
      <StatusBanner
        classNameWrapper={styles.notificationBanner}
        variant={variant}
      >
        {message}
      </StatusBanner>
    ),
    dismiss: {
      duration: 5000,
    },
  });
};

export const addErrorNotification = (message: string): void => {
  addNotification(message, 'ERROR');
};

export const addInfoNotification = (message: string): void => {
  addNotification(message, 'INFO');
};
